<template>
  <div>首页
      <!-- <div id="app">
        <el-cascader
          size="large"
          :options="options"
          v-model="selectedOptions"
          @change="handleChange">
        </el-cascader>
      </div> -->
  </div>
</template>

<script>
  // import { regionDataPlus } from 'element-china-area-data'
  export default {
    data () {
      return {
        // options: regionDataPlus,
        // selectedOptions: [],
      }
    },
	async mounted() {
		// var user = JSON.parse(localStorage.getItem('UserData'))
		// let res = await this.$http.getEmplooyeeRole(user.JobNumber)
		// console.log(res);
	},
    methods: {
      // handleChange (value) {
      //   console.log(value)
      // }
    }
  }
</script>

<style>

</style>
